module.exports = __webpack_public_path__ + "media/images/athletes/2831-0054d737c807c6a3985ccd1dd165a10e.png";